import locales, { DEFAULT_LOCALE } from "constants/locales"
import Router from "next/router"
import { omit } from "ramda"
import str from "utils/strings"

export const isIpad = () => {
  if (!process.browser) return false
  const ua = window.navigator.userAgent
  if (ua.indexOf("iPad") > -1) {
    return true
  }

  if (ua.indexOf("Macintosh") > -1) {
    try {
      document.createEvent("TouchEvent")
      return true
    } catch (e) {}
  }
  return false
}

export const changeLocale = (_locale, isPaymentReturnUrl) => {
  let locale = _locale
  if (str.locale === locale) return
  if (!locale || !(locale in locales)) {
    locale = DEFAULT_LOCALE
    if (isPaymentReturnUrl) {
      locale = localStorage.getItem("payment-locale") || locale
      localStorage.removeItem("payment-locale")
    }
  }
  str.locale = locale
  const pathname = Router.pathname.replace("[lang]", locale).replace("[hashedID]", Router.query?.hashedID)
  const query = omit(["lang", "hashedID"], Router.query)
  void Router.replace(
    {
      pathname,
      query: query
    },
    undefined,
    {
      shallow: true,
      scroll: false
    }
  )
}

export const goTo = ({ pathname, query, lang }) => {
  if (!pathname) return
  void Router.push({
    pathname: `${pathname}/${lang || str.locale || "en"}`,
    query: query
  })
}
